import { createContext } from 'react';
import { NotificationFunctionsType } from 'concert-ui-library';

export const NotificationContext = createContext({} as NotificationFunctionsType);
